import charts from '../charts.js';
import futuresChart from './futures.js';

const yAxisValues = {
	min: null,
	max: null,
}

function setPercentAxis(chart, config) {
	const min = chart.yAxis.getPrivate('selectionMinFinal');
	const max = chart.yAxis.getPrivate('selectionMaxFinal');

	if ((min !== yAxisValues.min || max !== yAxisValues.max) && min !== undefined && max !== undefined) {
		chart.percentAxis.setAll({
			min: ((min / config.lastData.close) - 1) * 100,
			max: ((max / config.lastData.close) - 1) * 100,
			start: 0,
			end: 1,
		});

		yAxisValues.min = min;
		yAxisValues.max = max;
	}
}

export default function({ id, data, config, dates }) {
	const chart = futuresChart({ id, data, config, dates });

	const seasonalitySelection = chart.addSeries(
		chart.lineSeries({
			name: 'seasonality_selection',
			valueYField: 'projected_close',
			stroke: charts.colours.blue,
			opacity: .2,
			strokeDasharray: charts.values.strokeDash,
		})
	);

	const seasonalitySelectionValue = chart.addSeries(
		chart.lineSeries({
			name: 'seasonality_selection_value',
			valueYField: 'seasonality_selection_value',
			stroke: charts.colours.pink,
			strokeWidth: 4,
			strokeDasharray: charts.values.strokeDash,
			tooltip: {
				labelFunction({ symbol, seasonality_selection, seasonality_selection_track_record, best_period }) {
					const text = [];

					if (seasonality_selection) {
						text.push(`${symbol} typically ${seasonality_selection < 0 ? 'decreases' : 'increases'} by ${Math.abs(seasonality_selection)}%, with a track record of ${seasonality_selection_track_record}% during this specific time window.`);
					}

					if (best_period) {
						text.push(`[bold]Best Period:[/] ${symbol} has risen by an average of [bold]${best_period.average}%[/] during this ${best_period.weeks}-week period with a track record of [bold]${best_period.track_record}%[/].`);
					}

					if (!text.length) {
						return null;
					}

					return text.join("\n\n");
				},
			},
		})
	);

	seasonalitySelection.hide();
	seasonalitySelectionValue.hide();

	chart.addSeries(
		chart.lineSeries({
			name: 'best_period',
			valueYField: 'best_period_value',
			stroke: charts.colours.green,
			strokeWidth: 6,
			layer: 6,
		})
	);

	chart.onReady(() => {
		setPercentAxis(chart, config);

		chart.percentAxis.show();
	});

	chart.yAxis.onPrivate('selectionMin', () => {
		setPercentAxis(chart, config);
	});

	chart.yAxis.onPrivate('selectionMax', () => {
		setPercentAxis(chart, config);
	});

	chart.chartReady();

	return chart;
};
